import { render, staticRenderFns } from "./WorkflowPanelControls.vue?vue&type=template&id=4dd2e2ba&"
import script from "./WorkflowPanelControls.vue?vue&type=script&lang=ts&"
export * from "./WorkflowPanelControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports